import React from 'react';

import CheckIcon from 'assets/pics/check.png';
import { useNEFISteps } from 'context/NEFIStepsContext';

import { TENANT_ID } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

import './NEFIStepsbar.sass';

export const NEFIStepsbar = () => {
  const { activeStep } = useNEFISteps();
  const isBAG = getTenantId() === TENANT_ID.BAG;
  const isAVA = getTenantId() === TENANT_ID.AVA;

  return (
    <div className="nefi-stepsbar">
      <div className="nefi-stepsbar__background-line" />

      <div className="nefi-stepsbar__steps">
        {[0, 1, 2, 3].map((step) => (
          <div key={`step_${step}`} className="nefi-stepsbar__step" />
        ))}
      </div>
      <div className="nefi-stepsbar__lines">
        {[1, 2, 3].map((step) => (
          <div
            key={`line_${step}`}
            className={`nefi-stepsbar__line ${activeStep >= step ? 'nefi-stepsbar__line--active' : ''}`}
          />
        ))}
      </div>
      <div className="nefi-stepsbar__steps-active">
        {[0, 1, 2, 3].map((step) => (
          <div
            key={`active_step_${step}`}
            className={`nefi-stepsbar__step-active ${
              activeStep >= step ? 'nefi-stepsbar__step-active--active' : ''
            }`}>
            {activeStep > step && (
              <div className="nefi-stepsbar__step-active--check-container">
                <img className="nefi-stepsbar__step-active--check" alt="check" src={CheckIcon} />
              </div>
            )}
            {activeStep === step && (
              <div className="nefi-stepsbar__step-active--number-container">
                <div
                  className={`nefi-stepsbar__step-active--number${isBAG ? ' bag' : ''}${
                    isAVA ? ' ava' : ''
                  }`}>
                  {step + 1}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
